import CardUsuario from './CardUsuario.component';

export default CardUsuario;
